import React from "react";
import "./ProductionPlants.css";
import plantsImage from "../assets/images/production-plants-hero.jpg";
import spainMap from "../assets/images/mapa-plantas.png";
import olloki1 from "../assets/images/p-olloki-1.jpg";
import olloki2 from "../assets/images/p-olloki-2.jpg";
import olloki3 from "../assets/images/p-olloki-3.jpg";

import huarte from "../assets/images/huarte.jpg";
import madrid from "../assets/images/madrid.jpg";
import cyndea from "../assets/images/cyndea.jpg";
import orliman from "../assets/images/orliman.jpg";
import videoPoster from "../assets/images/plantas-fab-poster.jpg";
import videoSrc from "../assets/videos/calidad-plantas-fabricacion-small-2.mp4";

const ProductionPlants = () => {
  return (
    <>
      {/* ================= HERO ================= */}
      <section
        className="plants-hero"
        style={{ backgroundImage: `url(${plantsImage})` }}
      >
        <div className="plants-hero-overlay" />

        <div className="plants-hero-text">
          <h1>
            <span className="green">4 plants</span>{" "}
            <span className="purple">and 2 R&amp;D+i</span>
            <br />
            <span className="green">centres</span>{" "}
            <span className="purple">in Spain</span>
          </h1>
        </div>
      </section>

      {/* ================= MAP SECTION ================= */}
      <section className="plants-map-section">
        <div className="plants-map-grid">

          <div className="plants-map-list">
            <ul>
              <li>
                <span className="marker">1</span>
                <p><strong>Cinfa Olloki</strong> | Plant | Olloki (Navarre)</p>
              </li>

              <li>
                <span className="marker">2</span>
                <p><strong>Cinfa Huarte</strong> | Plant and R&amp;D+i Centre | Huarte (Navarre)</p>
              </li>

              <li>
                <span className="marker">3</span>
                <p><strong>Cinfa Madrid</strong> | R&amp;D+i Centre | Alcalá de Henares (Madrid)</p>
              </li>

              <li>
                <span className="marker">4</span>
                <p><strong>Cyndea Pharma</strong> | Plant | Ólvega (Soria)</p>
              </li>

              <li>
                <span className="marker">5</span>
                <p><strong>Orliman</strong> | Plant | La Pobla de Vallbona (Valencia)</p>
              </li>
            </ul>
          </div>

          <div className="plants-map-image">
            <img src={spainMap} alt="Spain production plants map" />
          </div>

        </div>
      </section>
      <section className="plants-cards-section">
  <div className="plants-cards-grid">

    {/* ================= Cinfa Olloki (3 IMAGES) ================= */}
    {/* ================= Cinfa Olloki (FULL WIDTH) ================= */}
<div className="plant-card green full">
  <div className="plant-content">
    <h3>
      <span className="green">Cinfa</span>{" "}
      <span className="purple">Olloki</span>
    </h3>
    <p className="plant-type">Plant</p>
    <p>
      Headquarters and <strong>main facilities</strong>
    </p>
  </div>

  <div className="plant-images multi">
    <div style={{ backgroundImage: `url(${olloki1})` }} />
    <div style={{ backgroundImage: `url(${olloki2})` }} />
    <div style={{ backgroundImage: `url(${olloki3})` }} />
  </div>
</div>

    {/* ================= Cinfa Huarte ================= */}
    <div className="plant-card purple reverse">
      <div className="plant-content">
        <h3>
          <span className="green">Cinfa</span>{" "}
          <span className="purple">Huarte</span>
        </h3>
        <p className="plant-type">Plant and R&amp;D+i Centre</p>
        <p>R&amp;D+i, quality control, manufacturing and packaging of solids, liquids and flavours</p>
      </div>

      <div
        className="plant-images single"
        style={{ backgroundImage: `url(${huarte})` }}
      />
    </div>

    {/* ================= Cinfa Madrid ================= */}
    <div className="plant-card green">
      <div className="plant-content">
        <h3>
          <span className="green">Cinfa</span>{" "}
          <span className="purple">Madrid</span>
        </h3>
        <p className="plant-type">R&amp;D+i Centre</p>
        <p>Development of <strong>high value-added</strong> or <strong>complex medicines</strong></p>
      </div>

      <div
        className="plant-images single"
        style={{ backgroundImage: `url(${madrid})` }}
      />
    </div>

    {/* ================= Cyndea ================= */}
    <div className="plant-card purple reverse">
      <div className="plant-content">
        <h3 className="green">Cyndea Pharma</h3>
        <p className="plant-type">Plant</p>
        <p>Development and manufacturing of <strong>steroid based medicines</strong> and <strong>cancer treatments</strong></p>
      </div>

      <div
        className="plant-images single"
        style={{ backgroundImage: `url(${cyndea})` }}
      />
    </div>

    {/* ================= Orliman ================= */}
    <div className="plant-card green">
      <div className="plant-content">
        <h3 className="green">Orliman</h3>
        <p className="plant-type">Plant</p>
        <p>Development and manufacturing of <strong>orthopaedic products</strong></p>
      </div>

      <div
        className="plant-images single"
        style={{ backgroundImage: `url(${orliman})` }}
      />
    </div>

  </div>
</section>
 <section className="plants-video-section">
      <div className="plants-video-grid">

        {/* VIDEO */}
        <div className="plants-video-col video">
          <video
            className="plants-video"
            controls
            controlsList="nodownload"
            preload="metadata"
            poster={videoPoster}
          >
            <source src={videoSrc} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        {/* TEXT */}
        <div className="plants-video-col text">
          <h4>How does a medicine get made at Cinfa?</h4>
        </div>

      </div>
    </section>
    </>
  );
};

export default ProductionPlants;